import { render } from "./userlist.vue?vue&type=template&id=56ce9d7d&scoped=true&ts=true"
import script from "./userlist.vue?vue&type=script&lang=ts&name=PageUser"
export * from "./userlist.vue?vue&type=script&lang=ts&name=PageUser"

import "./userlist.vue?vue&type=style&index=0&id=56ce9d7d&lang=scss&scoped=true"
import "./userlist.vue?vue&type=style&index=1&id=56ce9d7d&lang=scss"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ce9d7d"]])

export default __exports__